module.exports = __webpack_public_path__ + "static/scale-model-of-idlewild-park-in-reno-nevada-fe925eebd0e27e2d8e728db90af7a890.png";